import React from "react";

// reactstrap components
import {

  Container
} from "reactstrap";

// core components
import ColorNavbar from "components/Navbars/ColorNavbar.js";
import downloadPdfFromJson from "utils/downloadPdfFromJson.js";

function Procesos() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("about-us");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("about-us");
    };
  });
  return (
    <>
      <ColorNavbar />
      <div className="main" style={{ marginTop: "8em" }}>
        <div className="section">
          <Container>
            <h3 className="title-uppercase text-center" style={{fontWeight:500,fontFamily: "'Noto Sans SC', sans-serif"}}>
              Toma de decisiones
            </h3>
            <center className="mt-5">
              <a
                href="#procedimiento-toma-de-decisiones"
                role="button"
                style={{textDecoration: "none !important", cursor: "pointer"}}
                onClick={(e) => {
                  e.preventDefault();
                  downloadPdfFromJson(
                    "/procedimiento-toma-de-decisiones.json",
                    "procedimiento-toma-de-decisiones.pdf"
                  );
                }}
              >
                <img
                  alt="Imagen con referencia Toma de Decisiones"
                  width="80px"
                  src={require("assets/img/sections/pdf.jpg")}
                ></img>
                <h6 className="my-3">Toma de Decisiones</h6>
              </a>
            </center>
          </Container>
        </div>
      </div>
    </>
  );
}

export default Procesos;
